import { render, staticRenderFns } from "./RejectReasonConfirm.vue?vue&type=template&id=0c94514d&scoped=true&"
import script from "./RejectReasonConfirm.vue?vue&type=script&lang=ts&"
export * from "./RejectReasonConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./RejectReasonConfirm.vue?vue&type=style&index=0&id=0c94514d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c94514d",
  null
  
)

export default component.exports